import { NavLink } from 'react-router-dom';

// Primary tabs in the bottom bar; everything else lives behind /more.
// Meals takes the 4th slot over Trails because meals happen 3-4×/day
// during the trip; trails maybe 1×/day. Trails lives under More (in the
// Trip Plan section, near Excursions).
const TABS = [
  { to: '/', label: 'Hub', icon: HubIcon, end: true },
  { to: '/today', label: 'Today', icon: TodayIcon },
  { to: '/wilman', label: 'Wilman', icon: WilmanIcon },
  { to: '/meals', label: 'Meals', icon: MealsIcon },
  { to: '/more', label: 'More', icon: MoreIcon },
];

export default function BottomTabBar() {
  return (
    <nav
      className="tab-bar fixed inset-x-0 bottom-0 z-30 border-t border-border-tertiary bg-bg-primary/95 backdrop-blur"
      aria-label="Primary"
    >
      <ul className="mx-auto flex h-14 max-w-screen-sm items-stretch justify-around">
        {TABS.map(({ to, label, icon: Icon, end }) => (
          <li key={to} className="flex-1">
            <NavLink
              to={to}
              end={end}
              className={({ isActive }) =>
                [
                  'flex h-full flex-col items-center justify-center gap-0.5 text-[10px] font-mono uppercase tracking-wider transition',
                  isActive ? 'text-action' : 'text-fg-tertiary hover:text-fg-secondary',
                ].join(' ')
              }
            >
              {({ isActive }) => (
                <>
                  <Icon active={isActive} />
                  <span>{label}</span>
                </>
              )}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}

const baseIconProps = {
  width: 22,
  height: 22,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.5,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  'aria-hidden': true,
};

function HubIcon({ active }) {
  return (
    <svg {...baseIconProps} strokeWidth={active ? 2 : 1.5}>
      <path d="M3 11.5 12 4l9 7.5" />
      <path d="M5 10.5V20h14v-9.5" />
      <path d="M10 20v-5h4v5" />
    </svg>
  );
}
function TodayIcon({ active }) {
  return (
    <svg {...baseIconProps} strokeWidth={active ? 2 : 1.5}>
      <circle cx="12" cy="12" r="3.5" />
      <path d="M12 3v2M12 19v2M3 12h2M19 12h2M5.6 5.6l1.4 1.4M17 17l1.4 1.4M5.6 18.4 7 17M17 7l1.4-1.4" />
    </svg>
  );
}
function WilmanIcon({ active }) {
  return (
    <svg {...baseIconProps} strokeWidth={active ? 2 : 1.5}>
      <path d="M4 8h16v8H4z" />
      <path d="M4 12h16" />
      <path d="M9 16v3M15 16v3" />
      <circle cx="8" cy="11" r="0.6" fill="currentColor" />
      <circle cx="16" cy="11" r="0.6" fill="currentColor" />
    </svg>
  );
}
function MealsIcon({ active }) {
  // Fork + knife — most legible meal glyph at 22px in a forest-themed
  // monochrome bar.
  return (
    <svg {...baseIconProps} strokeWidth={active ? 2 : 1.5}>
      <path d="M7 3v8M7 11a2 2 0 1 1 0-4M7 11v10" />
      <path d="M16 3v18M14 3v6a2 2 0 0 0 4 0V3" />
    </svg>
  );
}
function MoreIcon({ active }) {
  return (
    <svg {...baseIconProps} strokeWidth={active ? 2 : 1.5}>
      <circle cx="6" cy="12" r="1.2" fill="currentColor" />
      <circle cx="12" cy="12" r="1.2" fill="currentColor" />
      <circle cx="18" cy="12" r="1.2" fill="currentColor" />
    </svg>
  );
}
